import { injectable } from 'inversify';
import 'reflect-metadata';
import Cookies from 'js-cookie';
import { isEmpty, has } from 'lodash';

@injectable()
class CookieService {
  get = (key) => {
    return Cookies.get(key);
  };

  getAll = () => {
    return Cookies.get();
  };

  set = (key, value, attributes = {}) => {
    Cookies.set(key, value, attributes);
  };

  delete = (key, attributes) => {
    Cookies.remove(key, attributes);
  };

  deleteAll(attributes) {
    if (isEmpty(attributes)) {
      /* eslint-disable-next-line no-console */
      console.warn(
        'Pass the exact same path and domain attributes that were used to set the cookie',
      );
      return;
    }

    const cookies = this.getAll();

    Object.keys(cookies).forEach((cookieName) => {
      if (has(cookies, cookieName)) {
        this.delete(cookieName, attributes);
      }
    });
  }
}

export default CookieService;
